/**
 * 全局 Message 实例，供非组件上下文（axios、api、utils、directives）使用。
 * 需在应用内通过 setGlobalMessage 注入（通常在 XMessage 子组件中，如 MessageGlobalInit）。
 */
export interface GlobalMessageLike {
  info?(content: string): void
  error(content: string): void
  success(content: string): void
  warning(content: string): void
}

const messageStore: { current: GlobalMessageLike | null } = { current: null }

export function setGlobalMessage(m: GlobalMessageLike | null) {
  messageStore.current = m
}

export function getMessage(): GlobalMessageLike | null {
  return messageStore.current
}
